module.exports = __webpack_public_path__ + "static/media/400104_01.30e977d9.png";